import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import { APP_KEY_BLOWFISH2 } from "@ipru-common/constants/SiteConstants";
import useBlowFish from "@ipru-common/hooks/useBlowFish";
import GlobalStore from "@ipru-common/store/GlobalStore";
import {
  convertToISODate,
  getNetCorePageInputs,
  getSelectedFunds,
  readQueryParams,
} from "@ipru-common/utils/CommonFunctions";

const getSignatureSecureNetCoreInput = () => {
  const { quoteFormData, calculatorFormData, currentPageStep, appFormData } = GlobalStore.getSnapshot();
  const { personalDetails } = appFormData;
  const { encryptBlowfish } = useBlowFish({ key: APP_KEY_BLOWFISH2 });

  const queryParams = readQueryParams();

  function getOnlineReturnByRate(rate) {
    const items = quoteFormData?.calculatedData?.returns?.arr || [];
    const match = items.find((item) => item.rateOfInterest === rate);
    return match?.onlineReturn || null;
  }
  const qData = getNetCorePageInputs(calculatorFormData);
  const encodedQData = encryptBlowfish(JSON.stringify(qData));
  return {
    dob: convertToISODate(calculatorFormData.user_dob),
    annual_income: calculatorFormData?.yr_income,
    mobile: calculatorFormData?.mobileno,
    email_id: calculatorFormData?.emailid,
    gender: calculatorFormData?.gender,
    occupation: calculatorFormData?.calc_occupation,
    city: calculatorFormData?.city,
    pin: calculatorFormData?.pincode,
    qualification: calculatorFormData?.calc_education,
    premium: quoteFormData?.invest,
    lifecover: quoteFormData?.lifeCover,
    arr_4: getOnlineReturnByRate(4),
    arr_8: getOnlineReturnByRate(8),
    guaranteed_benefit: quoteFormData?.saMultiple === 10 ? quoteFormData?.invest : quoteFormData?.invest * 1.4,
    fund_name: getSelectedFunds(quoteFormData?.allocatedFunds)?.[0]?.Fund,
    qdata: queryParams?.get("qdata") || encodedQData,
    tax_saved: quoteFormData?.calculatedData?.totalTaxSavingUnder80C,
    marital_status: personalDetails?.marital_status,
    app_no: appFormData?.appNO,
    customer_name: personalDetails?.full_name,

    // NOT IN GPP-FLEXI, BUT NEEDED BEC OF COMMON IMPLEMENTATION
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    isenglish: "TRUE",
    currentpagestep: currentPageStep,
  };
};

export default getSignatureSecureNetCoreInput;
